import { PackageStatus } from '@allocab/allocab-dedicated-driver-types/lib/src/dedicated-package/types';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Table } from '../../components/table/Table';
import {
  PACKAGES_LIMIT,
  prefetchTripPackagesPageByDriverKey,
  useFetchTripPackagesByDriverKey,
} from '../../hooks/useFetchTripPackagesByDriverKey';
import { useDriverOptions } from '../../services/driver-options/useDriverOptions';
import { columns } from '../_authenticated._main.trips.trip-package/tableData';
import { TripPackageFilters } from '../_authenticated._main.trips.trip-package/TripPackageFilters';
import { STATUS_SEARCH_PARAMS_KEY } from '../_authenticated._main.trips.trip-package/TripPackageStatusFilter';

const tableStatus = ['ACCEPTED', 'CANCELLED', 'DRAFT', 'IN_PROGRESS', 'PROPOSED', 'TERMINATED'];

type Props = {
  driverKey: string;
};

export const DriverTripPackageTable = ({ driverKey }: Props) => {
  const { driverOptions } = useDriverOptions();

  const [searchParams] = useSearchParams();
  const currentPage = Math.max(parseInt(searchParams.get('page') ?? '1'), 1);
  const direction = (searchParams.get('direction') ?? 'desc') as 'desc' | 'asc';
  const orderBy = searchParams.get('orderBy') ?? 'startDate';
  const status = (searchParams.get(STATUS_SEARCH_PARAMS_KEY)?.split(',') ?? tableStatus) as PackageStatus[];

  const {
    data: dataDriver,
    isLoading: isLoadingDriver,
    isFetching: isFetchingDriver,
    isPreviousData: isPreviousDataDriver,
  } = useFetchTripPackagesByDriverKey(
    driverKey,
    {
      direction,
      orderBy,
      status,
    },
    currentPage,
  );

  const nbPages = Math.ceil((dataDriver?.totalItems ?? 0) / PACKAGES_LIMIT);

  useEffect(() => {
    if (currentPage > 1) {
      prefetchTripPackagesPageByDriverKey(driverKey, { direction, orderBy, status }, currentPage - 1);
    }
    if (currentPage < nbPages) {
      prefetchTripPackagesPageByDriverKey(driverKey, { direction, orderBy, status }, currentPage + 1);
    }
  }, [currentPage, direction, nbPages, status, orderBy, driverKey]);

  return (
    <div>
      <TripPackageFilters />
      <Table
        identifier="id"
        columns={columns}
        data={dataDriver?.items}
        isLoading={isLoadingDriver}
        isFetching={isPreviousDataDriver && isFetchingDriver}
        nbPages={nbPages}
        context={driverOptions}
        totalItems={dataDriver?.totalItems ?? 0}
      />
    </div>
  );
};
